// extracted by mini-css-extract-plugin
export default {"teamPage":"TeamPage_teamPage__K5dFD","content":"TeamPage_content__tZc0i"};